import React from "react";

export const Features = () => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Features</h2>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-3">
            <i className="fa fa-industry"></i>
            <h3>High-Quality Packaging</h3>
            <p>
              Providing reliable paper and plastic packaging solutions for
              businesses.
            </p>
          </div>
          <div className="col-xs-6 col-md-3">
            <i className="fa fa-handshake"></i>
            <h3>Efficient Trading</h3>
            <p>
              Streamlining B2B trade with cost-effective and scalable solutions.
            </p>
          </div>
          <div className="col-xs-6 col-md-3">
            <i className="fa fa-truck"></i>
            <h3>Timely Delivery</h3>
            <p>
              Ensuring timely delivery of goods to keep your business running
              smoothly.
            </p>
          </div>
          <div className="col-xs-6 col-md-3">
            <i className="fa fa-chart-line"></i>
            <h3>Expanding Horizons</h3>
            <p>
              Exploring new markets and goods to cater to your diverse needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
